const steps = [
  {
    step: "01",
    title: "Choose Your Speed",
    description:
      "Select same-day emergency (24–72 hours), rush (4–7 business days), or standard expedited (2–3 weeks) based on your travel deadline. For Clearwater residents, we recommend starting with your departure date from Tampa International (TPA) or St. Pete-Clearwater (PIE) and working backward.",
    icon: "ri-speed-line",
  },
  {
    step: "02",
    title: "Complete Your Application",
    description:
      "Fill out the correct DS-11 (new/first-time) or DS-82 (renewal) form online. Our system flags common errors in real time — wrong date formats, mismatched names, and missing fields. If you are applying for a child passport, we guide you through the DS-3053 parental consent requirements.",
    icon: "ri-file-list-3-line",
  },
  {
    step: "03",
    title: "Visit a Local Acceptance Facility",
    description:
      "New and child passports require an in-person appearance at a registered acceptance agent. We direct you to the nearest facility in Pinellas County — USPS Clearwater Main, USPS St. Petersburg, USPS Largo, USPS Dunedin, or the Pinellas County Clerk of Court — and confirm their current hours and wait times.",
    icon: "ri-map-pin-line",
  },
  {
    step: "04",
    title: "We Handle the Rest",
    description:
      "Once your application is sealed by the acceptance agent, overnight it to our registered courier hub using our pre-paid label. From there, your application enters the State Department's expedited queue through our authorized channel. You receive tracking updates at every milestone.",
    icon: "ri-truck-line",
  },
  {
    step: "05",
    title: "Receive Your Passport in Clearwater",
    description:
      "Your new passport ships via FedEx or UPS directly to your Clearwater home, office, or condo. We coordinate delivery timing so someone is available to sign. Most Clearwater residents receive their emergency passport within 24–72 hours of our courier receiving the sealed application.",
    icon: "ri-passport-line",
  },
];

export default function ClearwaterHowItWorksSection() {
  return (
    <section id="how-it-works" className="py-16 md:py-20 bg-[#F8F9FB]">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <span className="inline-block text-[#B22222] text-xs font-bold uppercase tracking-[0.15em] mb-3">
            Our Process
          </span>
          <h2 className="font-serif text-2xl md:text-4xl font-bold text-[#1A365D] mb-4">
            How Our Clearwater Passport Service Works
          </h2>
          <p className="text-gray-600 text-sm md:text-base max-w-2xl mx-auto leading-relaxed">
            A simple five-step process designed for busy Pinellas County residents — from choosing
            your speed to holding your new passport on Clearwater Beach.
          </p>
        </div>

        <div className="grid md:grid-cols-5 gap-6">
          {steps.map((s, i) => (
            <div key={i} className="relative bg-white rounded-lg p-6 border border-gray-100 hover:border-[#F6C344]/50 transition-all">
              <div className="w-10 h-10 rounded-lg bg-[#1A365D] flex items-center justify-center mb-4">
                <i className={`${s.icon} text-white text-lg`}></i>
              </div>
              <div className="text-[#F6C344] text-xs font-bold mb-2">Step {s.step}</div>
              <h3 className="font-serif text-sm font-bold text-[#1A365D] mb-2">{s.title}</h3>
              <p className="text-gray-600 text-xs leading-relaxed">{s.description}</p>

              {i < steps.length - 1 && (
                <div className="hidden md:block absolute top-10 -right-3 text-[#F6C344] text-xl z-10">
                  <i className="ri-arrow-right-line"></i>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="mt-10 text-center">
          <a
            href="https://fastpassportcenter.com/checkout/"
            className="inline-flex items-center gap-2 bg-[#F6C344] hover:bg-[#e5b430] text-[#1A365D] font-bold text-sm px-8 py-3 rounded-md transition-all hover:scale-105 whitespace-nowrap"
          >
            Start My Application <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}